var scope_0 = require('/Users/pietro/GitHub/dtu/dtu-02806-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/645426e4372572813e82b2c0203b7656.js').default;
var scope_1 = require('/Users/pietro/GitHub/dtu/dtu-02806-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8c7d47f860bb06bd3ba15fc6b6a7978a.js').default;
var scope_2 = require('/Users/pietro/GitHub/dtu/dtu-02806-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9b24180c0ec9a1d2ae52301b43b26995.js').default;
var scope_3 = require('/Users/pietro/GitHub/dtu/dtu-02806-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e2425ece4602f571957924dc4a062e98.js').default;
var scope_4 = require('/Users/pietro/GitHub/dtu/dtu-02806-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    